import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PropertyApplicationCreationDto, PropertyDto } from '@workspace/data-types';
import { DialogLayoutAuraComponent } from '@workspace/ng-aura';
import { PropertyApplicationFormComponent } from '../form/property-application-form.component';
import { PropertyApplicationWorkflowExplanationComponent } from '../workflow-explanation/property-application-workflow-explanation.component';

export interface PropertyApplicationDialogData {
  property: PropertyDto;
  initialDto?: PropertyApplicationCreationDto;
  activeStep?: number;
}

@Component({
  selector: 'etxe-property-application-dialog',
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    DialogLayoutAuraComponent,
    PropertyApplicationFormComponent,
    PropertyApplicationWorkflowExplanationComponent,
  ],
  templateUrl: './property-application-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyApplicationDialogComponent {
  readonly dialogRef = inject(
    MatDialogRef<PropertyApplicationDialogComponent, PropertyApplicationCreationDto | undefined>,
  );
  readonly data = inject<PropertyApplicationDialogData>(MAT_DIALOG_DATA);

  readonly currentStep = signal<'workflow' | 'form'>('workflow');

  readonly dialogTitle = computed(() => {
    if (this.currentStep() === 'workflow') {
      return 'Processus de candidature';
    }
    return this.data?.activeStep === 3 ? 'Avis de valeur et offre finale' : 'Candidature pour ce bien';
  });

  onAcknowledgeWorkflow(): void {
    this.currentStep.set('form');
  }

  onBackToWorkflow(): void {
    this.currentStep.set('workflow');
  }

  onFormSubmit(dto: PropertyApplicationCreationDto): void {
    this.dialogRef.close(dto);
  }

  onCancel(): void {
    this.dialogRef.close(undefined);
  }
}
